import { Text, Title } from '@mantine/core'

const Header = () => {
  return (
    <>
      <Title style={{ marginTop: 64 }} mb="lg" order={2} fw="bold" ta="center">
        Drivers Benefits Enrollment Checker
      </Title>

      <Text mt="md" c="gray.8" ta="center">
        Verify if a driver is enrolled in The Black Car Fund Drivers Benefits
        Program by entering their TLC number or NY Driver’s License Number.
      </Text>
      <Text mt="xs" c="gray.8" ta="center">
        <Text fw="bolder" component="span">
          Note:
        </Text>{' '}
        The TLC number is the TLC License Number, not the number on their
        license plates.
      </Text>
      <Text mt="xs" c="gray.8" ta="center">
        Eligibility criteria can be found{' '}
        <Text
          component="a"
          fw="bold"
          href="https://ny.driversbenefits.org/eligibility/"
          c="blue"
          span
        >
          here.
        </Text>{' '}
        Call the Drivers Benefits for support at{' '}
        <Text component="a" fw="bold" href="tel:833-814-8590" c="blue" span>
          1-833-814-8590.
        </Text>
      </Text>
    </>
  )
}

export default Header
